import {
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH,
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED,
    BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_CANCEL,
} from "constants/action-types";

export const fetchConnectedBrands = () => ({ type: BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH });
export const fetchConnectedBrandsSuccess = (payload) => ({
    payload,
    type: BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED,
});
export const fetchConnectedBrandsError = (payload) => ({
    error: true,
    payload,
    type: BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_COMPLETED,
});
export const cancelFetchConnectedBrands = () => ({ type: BUYER_DASHBOARD_CONNECTED_BRANDS_FETCH_CANCEL });
